'use strict';

import template from './account_activation.html';

const controller = [
  'temporaryUser',
  'auth',

  function (temporaryUser, auth) {
    this.updateTempUser = function () {
      this.tempUser = temporaryUser.getData() || {};
    };

    this.showEmailForm = function () {
      this.isEmailFormVisible = true;
      this.newEmail = this.tempUser.email;
    };

    this.resendEmail = function (email) {
      var data;

      if (this.isLoading) {
        return;
      }

      data = {
        id: this.tempUser.id
      };

      if (email && email !== this.tempUser.email) {
        data.email = email;
      }

      this.isLoading = true;
      auth.resendActivationEmail(data)
        .then(function () {
          var hasEmailChanged = data.email;

          this.isEmailResent = true;
          this.updateTempUser();

          delete this.newEmail;
          delete this.isEmailFormVisible;

          if (hasEmailChanged) {
            delete this.isResendButtonDisabled;
          } else {
            this.isResendButtonDisabled = true;
          }
        }.bind(this))
        .finally(function () {
          delete this.isLoading;
        }.bind(this));
    };

    this.submitEmailForm = function () {
      if (this.newEmail && this.newEmail !== this.tempUser.email) {
        this.resendEmail(this.newEmail);
      } else {
        delete this.isEmailFormVisible;
      }
    };

    this.updateTempUser();
  }
];
const saAccountActivation = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&'
      },
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saAccountActivation;



// WEBPACK FOOTER //
// ./app/src/directives/account_activation.js